<template>
    <div class="main-section-row">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'MainSectionRow'
}
</script>

<style lang="scss" scoped>
    .main-section-row {
        display: flex;
        width: 100%;
        height: fit-content;
        padding: 0px;
        flex-direction: row;
       
    }
</style>